<script lang="ts">
    
    import { createEventDispatcher } from "svelte";

    export let src: string;

    const dispatch = createEventDispatcher();

    let isPlaying = false;
    let videoElement: HTMLVideoElement;

    function onSkip(): void {
        dispatch('close');
    }

    function onPlay(): void {
        isPlaying = true;
    }

    function onPause(): void {
        isPlaying = false;
    }

    function onEnded(): void {
        dispatch('close');
    }

    function onPlayClick(): void {
        videoElement?.play();
    }

</script>

<div class="video-modal" class:is-playing={isPlaying}>

    <button type="button" class="skip-btn" on:click={onSkip}>Saltar</button>

    <button type="button" class="play-btn" on:click={onPlayClick}>
        <img src="/images/play-circle.svg" alt="Reproducir">
    </button>

    <!-- svelte-ignore a11y-media-has-caption -->
    <video bind:this={videoElement} class="video" {src} autoplay playsinline on:play={onPlay} on:pause={onPause} on:ended={onEnded}></video>
</div>

<style lang="scss">

    .video-modal {
        position: fixed;
        z-index: 99999;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: #222;

        &:not(.is-playing) {

            .play-btn {
                display: block;
            }

        }
    }

    .play-btn {
        $size: 200px;
        display: none;
        position: absolute;
        z-index: 2;
        width: $size;
        height: $size;
        top: calc(50% - #{$size * 0.5});
        left: calc(50% - #{$size * 0.5});
        border: none;
        background-color: transparent;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .skip-btn {
        position: absolute;
        z-index: 2;
        top: 15px;
        left: 50%;
        transform: translateX(-50%);
    }

    .video {
        width: 100%;
        height: 100%;
    }

</style>
